export interface Trigger {
  triggerId: string;
  triggerName: string;
  objectId: string;
  objectType: string;
  taskType: string;
  triggerType: string;
  arguments: {
    [key in `CUSTOM_TYPE_${string}`]: string[];
  };
}

export interface TriggerArguments {
  title: string;
  emails: string[];
}

export interface CreateTriggerRequest {
  arguments: {
    [key in `CUSTOM_TYPE_${string}`]: string[];
  };
  triggerType: string;
  taskType: string;
}

export enum TriggerName {
  SalesforceNotification = "sfdc.notify",
}

export enum TriggerType {
  System = "SYSTEM",
}
